import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Select from "react-select";
import { getVariants, getFirstViableVariant, getCurrentValue } from "./helpers";
import { VariantDropdownProps, ReactSelectDropdownOption } from "./types";
import { customReactSelectStyles } from "./constants";
import { DropdownIndicator } from "./DropdownIndicator";

const StyledVariantDropdown = styled.div`
  padding: 10px 0;
`;

const Label = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 1.29;
  text-align: left;
  color: #222222;
  margin-bottom: 5px;
`;

// TODO: Work more with 1 variant? Need example of data
export function VariantDropdown({
  currentId,
  itemVariantOptions = [],
  overrideStyle = {},
  onVariantChange,
}: VariantDropdownProps): JSX.Element | null {
  const variants = getVariants(itemVariantOptions);
  const [body, setBody] = useState<HTMLElement | undefined>();

  useEffect(() => setBody(document?.body), []);

  /**
   * We should not show variant selector if it doesn't include the current variant
   * This can be caused by incorrect data from db, like in DAY30-519
   * and could cause navigations troubles.
   */
  const hasCurrentOption = variants.some(({ value }) => value === currentId);
  return itemVariantOptions?.length > 1 && hasCurrentOption ? (
    <StyledVariantDropdown>
      <Label>
        {getFirstViableVariant(itemVariantOptions[0], "name").toString()}
      </Label>
      <Select<ReactSelectDropdownOption>
        isOptionDisabled={(selection) => !!selection.isDisabled}
        inputId="variant"
        value={getCurrentValue(variants, currentId)}
        options={variants}
        menuPortalTarget={body}
        onChange={(selection) =>
          onVariantChange(selection as ReactSelectDropdownOption)
        }
        styles={{
          ...customReactSelectStyles,
          ...overrideStyle,
          container: (base) => ({ ...base, flex: 1 }),
        }}
        components={{ DropdownIndicator }}
        isSearchable={false}
      />
    </StyledVariantDropdown>
  ) : null;
}
